/**
 * Panel strings.
 *
 * `tr` is the source of truth: every other language is typed as
 * `typeof tr`, so adding a key without translating it fails the build rather
 * than shipping a blank label. Three languages, matching the mobile app.
 */
export const tr = {
  appName: "ContactPool",
  panelName: "Yönetim Paneli",

  signIn: "Giriş yap",
  signOut: "Çıkış yap",
  planFreeTitle: "Bu organizasyon ücretsiz planda",
  planFreeBody: "Ücretsiz planda veriler yalnızca mobil cihazlarda tutulur ve sunucuya yüklenmez — bu yüzden panelde gösterilecek bir kayıt yok. Premium\u2019a geçince kayıtlar buluta senkronlanır ve burada görünür.",
  planReadonlyTitle: "Abonelik sona erdi",
  planReadonlyBody: "Mevcut kayıtlar görüntülenebilir ama yeni değişiklikler yüklenmiyor. Abonelik yenilenmezse buluttaki kopya silinir.",
  planPurgedTitle: "Buluttaki kopya silindi",
  planPurgedBody: "Abonelik sona erdikten sonra sunucudaki veriler kaldırıldı. Kayıtlar mobil cihazlarda duruyor; yeniden abone olununca tekrar yüklenir.",
  email: "E-posta",
  password: "Şifre",
  signInFailed: "E-posta veya şifre hatalı",
  networkError: "Sunucuya ulaşılamadı",

  navOverview: "Genel bakış",
  navCompanies: "Şirketler",
  navProducts: "Ürünler",
  navSamples: "Numuneler",
  navTasks: "Görevler",
  navMembers: "Üyeler",

  organization: "Organizasyon",
  switchOrganization: "Organizasyon değiştir",

  search: "Ara",
  loading: "Yükleniyor…",
  empty: "Kayıt yok",
  error: "Bir sorun oluştu",
  retry: "Tekrar dene",
  previous: "Önceki",
  next: "Sonraki",
  total: "toplam",

  statCompanies: "Şirket",
  statProducts: "Ürün",
  statSamples: "Numune",
  statOpenTasks: "Açık görev",
  statOverdueTasks: "Geciken görev",
  statExpiringCertificates: "Süresi yaklaşan sertifika",

  companyName: "Şirket",
  rating: "Puan",
  notes: "Notlar",
  about: "Hakkında",
  locations: "Lokasyonlar",
  people: "Kişiler",
  contact: "İletişim",
  products: "Ürünler",
  samples: "Numuneler",
  certificates: "Sertifikalar",
  contracts: "Sözleşmeler",
  updatedAt: "Güncelleme",

  add: "Ekle",
  edit: "Düzenle",
  deleteAction: "Sil",
  confirmDelete: "Bu kayıt silinsin mi?",
  individual: "Şahıs",
  address: "Adres",
  personName: "Ad soyad",
  personTitle: "Unvan",
  channelValue: "Telefon, e-posta veya web adresi",
  ratingHint: "1–5 arası. Boş bırakılırsa puan kaldırılır.",
  newCompany: "Şirket ekle",
  newCompanyName: "Yeni şirketin adı",
  companyDeleteWarning: "Bu şirket; kişileri, lokasyonları, ürünleri, numuneleri, sertifikaları, sözleşmeleri ve dosyalarıyla birlikte silinir. Silme bütün cihazlara yayılır. Devam edilsin mi?",
  planRequiredWrite: "Kayıt eklemek ve düzenlemek için aktif bir abonelik gerekiyor. Abonelik mobil uygulamadan alınır.",

  taskTitle: "Görev",
  taskStatus: "Durum",
  taskDue: "Son tarih",
  statusOpen: "Açık",
  statusDone: "Tamamlandı",
  statusCancelled: "İptal",
  overdue: "Gecikti",

  members: "Üyeler",
  invitations: "Bekleyen davetler",
  invite: "Davet et",
  inviteSent: "Davet gönderildi",
  role: "Rol",
  roleAdmin: "Yönetici",
  roleViewer: "Görüntüleyici",
  remove: "Çıkar",
  revoke: "İptal et",
  joinedAt: "Katılma",
  confirmRemove: "Bu üye organizasyondan çıkarılsın mı?",
  lastAdmin: "Organizasyonda en az bir yönetici kalmalı",
  onlyAdmins: "Bu işlem için yönetici olman gerekiyor",
  cancel: "Vazgeç",
  save: "Kaydet",
  navCard: "Profil kartım",
  cardTitle: "Profil kartım",
  cardIntro: "Bu bilgiler, karşınızdaki kişi QR kodunuzu okuttuğunda ona gidecek olanlardır. Kart hesabınıza ait — organizasyon değiştirseniz de aynı kalır, her planda çalışır.",
  cardFullName: "Ad soyad",
  cardCompanyName: "Şirket",
  cardCompanyNameHelp: "Şirketiniz yoksa boş bırakın; kendi adınız şirket adı olarak kaydedilir.",
  cardJobTitle: "Unvan",
  cardPhone: "Telefon",
  cardEmail: "E-posta",
  cardEmailHelp: "Giriş yaptığınız adres değil; burada paylaşmak istediğiniz adres.",
  cardWebsite: "Web sitesi",
  cardCity: "Şehir",
  cardCountry: "Ülke",
  cardSaved: "Kart kaydedildi",
  cardPhoto: "Fotoğraf yükle",
  cardPhotoUploading: "Yükleniyor…",
  cardPhotoReady: "Fotoğraf yüklendi — kaydedince karta işlenir.",
  cardStopSharing: "Kartı sil",
  cardStopSharingWarning: "Kartınız silinir ve QR kodunuz çalışmaz. Daha önce kartınızı kaydetmiş kişilerdeki kopyalar kalır — verilen kartvizit geri alınmaz. Devam edilsin mi?",
  cardErrorNoContact: "En az bir telefon veya e-posta girin. Ulaşılamayan bir kart işe yaramaz.",
  cardErrorTooLarge: "Bilgileriniz okunabilir bir QR koda sığmıyor. Birkaç alanı kısaltın.",
  cardNotSetUp: "Kart henüz oluşturulmadı",
  cardNotSetUpHint: "Formu doldurup kaydedin; QR kodunuz burada belirir.",
  cardShowCodeHint: "Karşınızdaki kişi bunu ContactPool ile okutsun. Kart kodun içinde taşınır, internet gerekmez.",
  cardPrint: "Yazdır",
};

export type TranslationKey = keyof typeof tr;

export const en: typeof tr = {
  appName: "ContactPool",
  panelName: "Admin Panel",

  signIn: "Sign in",
  signOut: "Sign out",
  planFreeTitle: "This organization is on the free plan",
  planFreeBody: "On the free plan records stay on the mobile devices and are never uploaded, so there is nothing for the panel to show. Subscribing syncs them to the cloud and they appear here.",
  planReadonlyTitle: "The subscription has ended",
  planReadonlyBody: "Existing records can still be read, but new changes are not uploaded. If the subscription is not renewed the cloud copy is deleted.",
  planPurgedTitle: "The cloud copy was deleted",
  planPurgedBody: "Server-side data was removed after the subscription ended. Records are still on the mobile devices and upload again once you resubscribe.",
  email: "E-mail",
  password: "Password",
  signInFailed: "E-mail or password is wrong",
  networkError: "Could not reach the server",

  navOverview: "Overview",
  navCompanies: "Companies",
  navProducts: "Products",
  navSamples: "Samples",
  navTasks: "Tasks",
  navMembers: "Members",

  organization: "Organization",
  switchOrganization: "Switch organization",

  search: "Search",
  loading: "Loading…",
  empty: "Nothing here",
  error: "Something went wrong",
  retry: "Try again",
  previous: "Previous",
  next: "Next",
  total: "total",

  statCompanies: "Companies",
  statProducts: "Products",
  statSamples: "Samples",
  statOpenTasks: "Open tasks",
  statOverdueTasks: "Overdue tasks",
  statExpiringCertificates: "Expiring certificates",

  companyName: "Company",
  rating: "Rating",
  notes: "Notes",
  about: "About",
  locations: "Locations",
  people: "People",
  contact: "Contact",
  products: "Products",
  samples: "Samples",
  certificates: "Certificates",
  contracts: "Contracts",
  updatedAt: "Updated",

  add: "Add",
  edit: "Edit",
  deleteAction: "Delete",
  confirmDelete: "Delete this record?",
  individual: "Individual",
  address: "Address",
  personName: "Full name",
  personTitle: "Job title",
  channelValue: "Phone, e-mail or website",
  ratingHint: "1–5. Leave empty to clear the rating.",
  newCompany: "Add company",
  newCompanyName: "New company name",
  companyDeleteWarning: "This company will be deleted along with its people, locations, products, samples, certificates, contracts and files. The deletion reaches every device. Continue?",
  planRequiredWrite: "Adding and editing records needs an active subscription. Subscriptions are bought in the mobile app.",

  taskTitle: "Task",
  taskStatus: "Status",
  taskDue: "Due",
  statusOpen: "Open",
  statusDone: "Done",
  statusCancelled: "Cancelled",
  overdue: "Overdue",

  members: "Members",
  invitations: "Pending invitations",
  invite: "Invite",
  inviteSent: "Invitation sent",
  role: "Role",
  roleAdmin: "Admin",
  roleViewer: "Viewer",
  remove: "Remove",
  revoke: "Revoke",
  joinedAt: "Joined",
  confirmRemove: "Remove this member from the organization?",
  lastAdmin: "An organization must keep at least one admin",
  onlyAdmins: "You need to be an admin to do this",
  cancel: "Cancel",
  save: "Save",
  navCard: "My card",
  cardTitle: "My profile card",
  cardIntro: "This is what someone gets when they scan your QR code. The card belongs to your account — it stays the same whichever organisation you switch to, and it works on every plan.",
  cardFullName: "Full name",
  cardCompanyName: "Company",
  cardCompanyNameHelp: "Leave blank if you have no company; your own name is saved as the company name.",
  cardJobTitle: "Job title",
  cardPhone: "Phone",
  cardEmail: "E-mail",
  cardEmailHelp: "Not the address you sign in with \u2014 the one you want to hand out.",
  cardWebsite: "Website",
  cardCity: "City",
  cardCountry: "Country",
  cardSaved: "Card saved",
  cardPhoto: "Upload a photo",
  cardPhotoUploading: "Uploading\u2026",
  cardPhotoReady: "Photo uploaded \u2014 save the card to apply it.",
  cardStopSharing: "Delete card",
  cardStopSharingWarning: "Your card is deleted and your QR code stops working. Copies already saved by other people stay with them \u2014 a card handed over is not taken back. Continue?",
  cardErrorNoContact: "Add a phone number or an e-mail. A card nobody can reach you on is no use.",
  cardErrorTooLarge: "Your details will not fit in a scannable QR code. Shorten a field or two.",
  cardNotSetUp: "No card yet",
  cardNotSetUpHint: "Fill in the form and save; your QR code appears here.",
  cardShowCodeHint: "Have them scan this with ContactPool. The card travels inside the code, so no connection is needed.",
  cardPrint: "Print",
};

export const zh: typeof tr = {
  appName: "ContactPool",
  panelName: "管理面板",

  signIn: "登录",
  signOut: "退出登录",
  planFreeTitle: "该组织使用免费套餐",
  planFreeBody: "免费套餐下记录仅保存在移动设备上，不会上传到服务器，因此管理端没有可显示的数据。订阅后记录会同步到云端并显示在这里。",
  planReadonlyTitle: "订阅已结束",
  planReadonlyBody: "现有记录仍可查看，但新的更改不会上传。若不续订，云端副本将被删除。",
  planPurgedTitle: "云端副本已删除",
  planPurgedBody: "订阅结束后服务器上的数据已被移除。记录仍保存在移动设备上，重新订阅后会再次上传。",
  email: "邮箱",
  password: "密码",
  signInFailed: "邮箱或密码错误",
  networkError: "无法连接服务器",

  navOverview: "概览",
  navCompanies: "公司",
  navProducts: "产品",
  navSamples: "样品",
  navTasks: "任务",
  navMembers: "成员",

  organization: "组织",
  switchOrganization: "切换组织",

  search: "搜索",
  loading: "加载中…",
  empty: "暂无记录",
  error: "出现错误",
  retry: "重试",
  previous: "上一页",
  next: "下一页",
  total: "共计",

  statCompanies: "公司",
  statProducts: "产品",
  statSamples: "样品",
  statOpenTasks: "进行中任务",
  statOverdueTasks: "逾期任务",
  statExpiringCertificates: "即将到期证书",

  companyName: "公司",
  rating: "评分",
  notes: "备注",
  about: "关于",
  locations: "地点",
  people: "联系人",
  contact: "联系方式",
  products: "产品",
  samples: "样品",
  certificates: "证书",
  contracts: "合同",
  updatedAt: "更新时间",

  add: "添加",
  edit: "编辑",
  deleteAction: "删除",
  confirmDelete: "确定删除这条记录吗？",
  individual: "个人",
  address: "地址",
  personName: "姓名",
  personTitle: "职务",
  channelValue: "电话、邮箱或网址",
  ratingHint: "1–5。留空则清除评分。",
  newCompany: "添加公司",
  newCompanyName: "新公司名称",
  companyDeleteWarning: "该公司及其联系人、地址、产品、样品、证书、合同和文件都将被删除。删除会同步到所有设备。是否继续？",
  planRequiredWrite: "添加和编辑记录需要有效的订阅。请在手机应用中订阅。",

  taskTitle: "任务",
  taskStatus: "状态",
  taskDue: "截止",
  statusOpen: "进行中",
  statusDone: "已完成",
  statusCancelled: "已取消",
  overdue: "已逾期",

  members: "成员",
  invitations: "待接受的邀请",
  invite: "邀请",
  inviteSent: "邀请已发送",
  role: "角色",
  roleAdmin: "管理员",
  roleViewer: "查看者",
  remove: "移除",
  revoke: "撤销",
  joinedAt: "加入时间",
  confirmRemove: "将该成员移出组织？",
  lastAdmin: "组织必须至少保留一名管理员",
  onlyAdmins: "此操作需要管理员权限",
  cancel: "取消",
  save: "保存",
  navCard: "我的名片",
  cardTitle: "我的名片",
  cardIntro: "别人扫描你的二维码时收到的就是这些信息。名片属于你的账号——切换组织后依然不变，且所有套餐都可使用。",
  cardFullName: "姓名",
  cardCompanyName: "公司",
  cardCompanyNameHelp: "没有公司可留空，系统会把你的姓名作为公司名称保存。",
  cardJobTitle: "职位",
  cardPhone: "电话",
  cardEmail: "电子邮箱",
  cardEmailHelp: "不是登录用的邮箱，而是你想公开的那个。",
  cardWebsite: "网站",
  cardCity: "城市",
  cardCountry: "国家",
  cardSaved: "名片已保存",
  cardPhoto: "上传照片",
  cardPhotoUploading: "上传中…",
  cardPhotoReady: "照片已上传——保存名片后生效。",
  cardStopSharing: "删除名片",
  cardStopSharingWarning: "名片将被删除，二维码随之失效。别人已保存的副本仍会保留——递出去的名片收不回来。是否继续？",
  cardErrorNoContact: "请填写电话或邮箱。联系不上的名片没有意义。",
  cardErrorTooLarge: "信息太长，无法生成可扫描的二维码。请缩短几项。",
  cardNotSetUp: "尚未创建名片",
  cardNotSetUpHint: "填写并保存表单，二维码会显示在这里。",
  cardShowCodeHint: "请对方用 ContactPool 扫描。名片就在二维码里，无需联网。",
  cardPrint: "打印",
};

export const languages = { tr, en, zh };
export type LanguageCode = keyof typeof languages;
